import { Dispatch, SetStateAction } from "react";
import { EditFields } from "..";
import { Box } from "src/components/MuiGenerals";
import { TableRow } from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";
import InputFieldSection from "./components/InputFieldSection";
import InfoFieldSection from "./components/InfoFieldSection";

function Content({
  rowData,
  setFields,
  fields,
  isLowerThresholdInvalid,
  isUpperThresholdInvalid,
}: {
  rowData: TableRow;
  setFields: Dispatch<SetStateAction<EditFields>>;
  fields: EditFields;
  isLowerThresholdInvalid: boolean;
  isUpperThresholdInvalid: boolean;
}) {
  return (
    <Box
      sx={{
        ".MuiInputLabel-shrink": {
          display: "none",
        },
      }}
    >
      <InfoFieldSection rowData={rowData} />

      <hr style={{ opacity: 0.5, marginTop: "30px", marginBottom: "24px" }} />

      <InputFieldSection
        fields={fields}
        setFields={setFields}
        isLowerThresholdInvalid={isLowerThresholdInvalid}
        isUpperThresholdInvalid={isUpperThresholdInvalid}
      />
    </Box>
  );
}

export default Content;
